<template>
  <div class="Box">
    <el-card class="box-card">
      <div style="display: flex;">
        <h1 style="margin-bottom: 20px; margin-left: 120px">IAA充值模版</h1>
        <img src="../../../assets/帮助.png" @mouseover="indicateShow = true" @mouseleave="indicateShow = false"
             style="width: 20px;height: 20px;cursor: pointer;margin-left: 20px;" alt="">
      </div>


      <div class="Left">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="平台类型" style="margin-left: 120px">
            <el-select v-model="form.platform_type" placeholder="请选择活动区域"
                       @change="handleChange(form.platform_type)">
              <el-option v-for="dict in platform_typeList" :key="dict.id" :label="dict.name"
                         :value="dict.id" />
            </el-select>
          </el-form-item>
          <div style="display: flex;">
            <el-form-item label="" :label-width="formLabelWidth" prop="status">
              <div style="display: flex">
                <el-card class="box-card" style="background-color: #EEEEEE;">
                  <div slot="header" class="clearfix" style="position: relative;">
                    <span>充值档位</span>
                  </div>


                  <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
                    <draggable v-model="CZOne" :options="{ animation: 200 }"
                               style="display: flex;justify-content: space-between; flex-wrap: wrap;width: 400px;">
                      <div class="btnAd" v-for="(item, index) in CZOne" :key="index">
                        <div class="btnAd_wai" style="cursor:move;"
                             :class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
                          <div class="price">¥ {{ item.money }}</div>
                          <div>
                            <div style="position: relative" v-if="item.recharge_type == 0">
                              <div class="bi">{{ (item.money * 100).toFixed(0) }}k币<span
                                  style="color: #ec915f;"
                                  v-if="item.free_balance > 0">+{{ item.free_balance ?
                                  item.free_balance : 0
                                }}k币</span></div>
                              <div class="dingBtn" v-if="item.goods_mark_txt"
                                   style="background-color: #ed6c34;">{{
                                  item.goods_mark_txt }}</div>
                            </div>
                            <div v-else style="position: relative">
                              <div class="bi">{{ item.description }}</div>
                              <div class="dingBtn" v-if="item.goods_mark_txt"
                                   style="background-color: #ed6c34;">{{
                                  item.goods_mark_txt }}</div>
                            </div>
                          </div>

                          <div>
                            <!-- <div class="song">{{item.footer_mark_txt?item.footer_mark_txt:""}}</div> -->
                            <div class="song" v-if="item.recharge_type == 0"
                                 style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
                              {{ (item.footer_mark_txt && item.footer_mark_txt !=
                                undefined)
                                ? item.footer_mark_txt : "" }}</div>
                            <div class="song"
                                 style="background-color: #fc5e5d;color: #fff;font-weight: bold;"
                                 v-else>{{ (item.footer_mark_txt
                                && item.footer_mark_txt != undefined) ? item.footer_mark_txt
                                :
                                ""
                              }}</div>
                          </div>
                          <div style="width: 100%; height: 10px; position: relative;cursor:pointer;"
                               v-if="item.footer_mark_txt">
                            <i style="position: absolute; bottom: -12px; right: 5px;color: #000;"
                               class="el-icon-edit" @click="Updateitem(item, index)"></i>
                            <i style="position: absolute; bottom: -12px; right: 28px;color: #000;"
                               @click="deleteItem(index)" class="el-icon-delete"></i>
                          </div>
                          <div style="width: 100%; height: 10px; position: relative;cursor:pointer;"
                               v-else>
                            <i style="position: absolute; bottom: -40px; right: 5px;color: #000;"
                               class="el-icon-edit" @click="Updateitem(item, index)"></i>
                            <i style="position: absolute; bottom: -40px; right: 28px;color: #000;"
                               @click="deleteItem(index)" class="el-icon-delete"></i>
                          </div>
                        </div>


                      </div>
                      <div class="btnAds" @click="Dialog"
                           style="user-drag: none; -webkit-user-drag: none;">
                        <i class="el-icon-plus"></i>
                      </div>
                    </draggable>
                  </div>
                  <!-- <div class="btn">立即充值</div> -->
                </el-card>
              </div>
            </el-form-item>
          </div>

          <el-form-item style="margin-left: 70px;margin-top: 30px;">
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="None">重置</el-button>
          </el-form-item>
          <div v-show="indicateShow"
               style="width: 600px;height: 450px;position: absolute;top: 0px;left: 240px;">
            <img src="../../../assets/引导.png" style="width: 600px;height: 450px" alt="">
          </div>
        </el-form>

      </div>
      <el-dialog title="添加" :close-on-click-modal="false" :visible.sync="dialogVisible" width="50%"
                 :before-close="handleClose">
        <div class="waiAdd">
          <el-form :model="Yiform" label-width="150px" class="demo-ruleForm" ref="ruleForm" :rules="rules">
            <el-form-item label="充值类型" :label-width="formLabelWidth" prop="recharge_type"
                          label-width="150px">
              <el-select v-model="Yiform.recharge_type" placeholder="请选择活动区域">
<!--                <el-option key="1" label="VIP充值" value="1" />-->
                <el-option v-for="dict in recharge_typeList" :key="dict.id" :label="dict.name"
                           :value="dict.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="VIP充值金额" label-width="150px" prop="money" :rules="[
								{ required: true, message: '请选择VIP充值金额', trigger: 'change' }
							]">
              <el-select v-model="Yiform.money" filterable @change="handleOption(Yiform.money)">
                <el-option v-for="dict in YiformList" :key="dict.id" :label="dict.customField"
                           :value="dict.id" />
              </el-select>
            </el-form-item>
            <el-form-item  label="VIP天数" :label-width="formLabelWidth" prop="day">
              <el-input v-model="this.Addday.day" disabled></el-input>
            </el-form-item>
            <el-form-item label="VIP提示语" :label-width="formLabelWidth" prop="description">
              <el-input v-model="Yiform.description"></el-input>
            </el-form-item>
            <el-form-item label="角标文案" :label-width="formLabelWidth" prop="goods_mark_txt" :rules="[
							{ validator: validateMaxJiaoLength, message: '角标文案不能超过4个字', trigger: 'blur' }
						]">
              <el-input v-model="Yiform.goods_mark_txt" placeholder="请输入角标文案(不超过4个字)，默认展示特惠"></el-input>
            </el-form-item>
            <el-form-item label="提示文案(底部浮标)" :label-width="formLabelWidth" prop="footer_mark_txt" :rules="[
							{ validator: validateMaxLength, message: '提示语不能超过10个字', trigger: 'blur' }
						]">
              <el-input v-model="Yiform.footer_mark_txt" placeholder="请输入提示文案(不超过10个字)，默认展示开通会员"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisiblePush">取 消</el-button>
					<el-button type="primary" @click="submitForm">确 定</el-button>
				</span>
      </el-dialog>
    </el-card>
    <!-- 弹框 -->

  </div>
</template>
<script>
import { VipApi } from '@/api/vipRecharge/index';
import { processErrors } from '@/utils/errorHandler';
import { Session } from '@/utils/storage';
import draggable from "vuedraggable"
export default {
  components: { draggable },
  data() {
    return {
      indicateShow: false,
      formLabelWidth: '',
      states: true,
      show: 0,
      form: {
        platform_type: 0,
        is_open:0,
        w_recharge_gear: [], //未充值
        y_recharge_gear: [], //已充值
        type:1
      },
      Addday: {},
      CZOne: [],
      dialogVisible: false,
      Yiform: {
        description: "",
        recharge_type: 1, //是否是vip
        money: '', //充值金额
        free_balance: '', //赠送书币
        goods_mark_txt: '', //提示语
        balance_all: '',
        balance: '',
        footer_mark_txt: ""
      },
      YiformListAll: [],
      YiformList: [],
      recharge_typeList: [
        { id: 1, name: 'VIP充值' },
      ],
      platform_typeList: [
        { id: 0, name: '默认' },
        { id: 1, name: '抖音' },
        { id: 2, name: '微信' },
      ],
      rules: {
        recharge_type: [{ required: true, message: '请输入充值类型', trigger: 'blur' }],
        money: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
        balance: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
      },
      VIP_update: false,
    };
  },
  methods: {
    //提示文案
    validateMaxLength(rule, value, callback) {
      if (!value) {
        return callback(); // 直接通过验证
      }

      let byteLen = 0;
      for (let i = 0; i < value.length; i++) {
        const c = value.charCodeAt(i);
        // 单字节加1，中文字符加3
        byteLen += c >= 0 && c <= 255 ? 1 : 3;
      }

      const maxLength = 30; // 最大字符长度
      if (byteLen > maxLength) {
        callback(new Error(`提示文案不能超过 ${maxLength} 个字`));
      } else {
        callback(); // 验证通过
      }
    },

    //角标文案
    validateMaxJiaoLength(rule, value, callback) {

      const maxLength = 4; // 最大字符长度
      if (value && value.length > maxLength) {
        callback(new Error(`角标文案不能超过 ${maxLength} 个字`));
      } else {
        callback(); // 验证通过
      }
    },
    handleChange(e) {
      const api = VipApi();
      let params = {
        platform_type: 0,
        type: 1
      }
      // let platform_type = 0;
      if (e == 1) {
        params.platform_type = 1;
      } else if (e == 2) {
        params.platform_type = 2;
      }
      api.goods_rechargeinfo(params).then((response) => {
        if (response.data.length == 0) {
          this.CZOne = [];
        } else {
          this.CZOne = response.data.y_recharge_gear;
        }
      });
    },
    dialogVisiblePush() {
      this.dialogVisible = false
      this.show = 0
      // this.$refs.ruleForm.resetFields();
    },
    Dialog() {
      
      this.states = true;
      
      this.VIP_update = false
      this.dialogVisible = true;
      if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        } 
      this.Yiform = {
        recharge_type: 1, //是否是vip
        // money: '', //充值金额
        free_balance: '', //赠送书币
        goods_mark_txt: '', //提示语
      };
    },

    deleteItem(index) {
      this.CZOne.splice(index, 1);
    },
    Updateitem(item, index) {
      this.states = true;
      this.VIP_update = true
      Session.set('indexArr', index);
      this.show = 1;
      this.dialogVisible = true;
      this.Yiform = item;
      this.Addday = {
        ...item,
        money: item.money,
        day: item.day,
        description: item.description,
      };
      this.Yiform = this.Addday;
      let params = {
        sort: 'money',
        sortType: 'asc',
      };
      const api = VipApi();
      api.getvipList(params)
          .then((res) => {
            if (res.code == 0) {
              // this.YiformList = res.data.data
              this.YiformList = res.data.data.map((item) => ({
                ...item, // 保留原始对象的所有属性
                customField: `${item.money}元 = ${item.day}天会员`, // 添加新的 customField 字段
              }));
              this.YiformListAll = res.data.data;
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
            console.error('Error fetching user data:', error);
            this.loading = false;
          });
    },
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
            if (this.show == 0) {
              let ar = {
                ...this.Yiform,
                footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
                goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
                money: this.Addday.money,
                day: this.Addday.day,
                description: this.Addday.description ? this.Addday.description : "全站免费看",
              };
              this.CZOne.push(ar);
              (this.Yiform = {
                recharge_type: 0, //是否是vip
                money: '', //充值金额
                free_balance: '', //赠送书币
                goods_mark_txt: '', //提示语
              }),
                  (this.dialogVisible = false);
              this.show = 0;
            } else {
              let ar = {
                ...this.Yiform,
                footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
                goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
                description: this.Addday.description ? this.Addday.description : "全站免费看",
                money: this.Addday.money,
                day: this.Addday.day,
                // description: this.Addday.description,
              };
              let index = Session.get('indexArr');
              this.CZOne[index] = ar;
              this.dialogVisible = false;
              this.show = 0;
            }
          }
      });
    },

    onSubmit() {
      const { w_recharge_gear, ...formDataWithoutW } = this.form;
      const formDataY = {
        ...formDataWithoutW,
        y_recharge_gear: JSON.stringify(this.CZOne), // 将VIP天数添加到表单数据中
        // 其他表单项根据需要添加
      };
      if (this.CZOne.length < 4) {
        this.$message.error('至少添加4个额度');
      } else {
        const api = VipApi();
        api.getvipedit(formDataY).then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.Getinfos();
          } else {
            processErrors(res);
          }
        });
      }
    },
    handleOption(e) {
      this.Addday = this.YiformListAll.find((item) => item.id === e);
      this.Yiform.money = this.Addday.money;
      if (this.VIP_update) {
        this.Yiform.description = this.Addday.description;
      } else {
      }
    },
    None() {
      this.Getinfos()
      // this.form = {
      // 	recharge_tag: 0,
      // 	is_open: 0,
      // 	platform_type: 1,
      // 	w_recharge_gear: [], //未充值
      // 	y_recharge_gear: [], //已充值
      // };
    },
    handleSelectChange() {

      // if (this.Yiform.recharge_type == 1) {
      //   this.$refs.ruleForm.resetFields();
      //   this.Yiform = {
      //     recharge_type: 1, //是否是vip
      //     money: '', //充值金额
      //     free_balance: '', //赠送书币
      //     goods_mark_txt: '', //提示语
      //     footer_mark_txt: "",
      //     balance_all: "",
      //     balance: ""
      //   }
      //   this.Addday.day = ""
      //   this.Addday.description = ""
        // (this.Yiform.money = ''), (this.Yiform.goods_mark_txt = '');
        // this.Yiform.free_balance = '';
        let params = {
          sort: 'money',
          sortType: 'asc',
        };
        const api = VipApi();
        api.getvipList(params)
            .then((res) => {
              if (res.code == 0) {
                // this.YiformList = res.data.data
                this.YiformList = res.data.data.map((item) => ({
                  ...item, // 保留原始对象的所有属性
                  customField: `${item.money}元 = ${item.day}天会员`, // 添加新的 customField 字段
                }));
                this.YiformListAll = res.data.data;
              } else {
                processErrors(res);
              }
            })
            .catch((error) => {
              this.loading = false;
            });
      // }
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.show = 0
      this.$refs.ruleForm.resetFields();
      // done();
      // this.$refs['ruleForm'].resetFields();
      this.Yiform = {
        recharge_type: 0, //是否是vip
        balance: 0, //充值金额
        free_balance: '', //赠送书币
        goods_mark_txt: '', //提示语
      };
    },
    //详情接口
    Getinfos() {
      const api = VipApi();
      let params = {
        platform_type: this.form.platform_type,
        type: 1
      }
      api.goods_rechargeinfo(params).then((response) => {
        // this.form = response.data;
        // this.form.is_open = response.data.is_open;
        // this.form.recharge_tag = response.data.recharge_tag;
        // this.CZOne = response.data.y_recharge_gear;
        if (response.data.length == 0) {
          // this.form.is_open = 1;
          this.CZOne = this.form.y_recharge_gear;
          // this.CZTwo = this.form.w_recharge_gear;
          // this.form.recharge_tag = 0;
        } else {
          this.CZOne = response.data.y_recharge_gear;
          // this.CZTwo = response.data.w_recharge_gear;
        }
        // this.CZTwo = response.data.w_recharge_gear;
      });
    },
  },
  mounted() {
    this.Getinfos();
    this.handleSelectChange();
  },
};
</script>
<style lang="scss" scoped>
.el-card__body {
  background-color: #1890ff;
}

.Box {
  .Left {
    width: 60%;
    height: 100%;
    position: relative;

    .text {
      font-size: 14px;
    }

    .item {
      margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: '';
    }

    .clearfix:after {
      clear: both;
    }

    .box-card {
      width: 380px;
      margin-left: 50px;

      .btn {
        width: 100%;
        height: 30px;
        background-color: #1890ff;
        color: #fff;
        border-radius: 32px;
        margin-top: 10px;
        line-height: 30px;
        text-align: center;
      }

      .white-background {
        background-color: #fff;
        // color: #d24757;
      }

      .black-background {

        background-color: white;
        background-image: url('../../../assets/zhuan.png');
        background-size: cover;
        /* 使背景图覆盖整个容器 */
        background-position: center;
        /* 背景图居中对齐 */
        background-repeat: no-repeat;
        //  背景图不重复
        height: 100vh;
      }

      .btnAd {
        width: 150px;
        height: 120px;
        // border: #ccc 1px solid;
        border-radius: 10px;
        margin-top: 10px;
        padding: 0px 0;

        .btnAd_wai {
          border-radius: 10px;
          width: 150px;
          height: 100px;

          .price {
            color: #000;
            height: 20px;
            font-size: 15px;
            line-height: 60px;
            text-align: center;
            font-size: 18px;
            font-weight: bold;
          }

          .bi {
            font-size: 10px;
            margin-top: 10px;
            // margin-top: 6px;
            text-align: center;
          }

          .dingBtn {
            position: absolute;
            top: -30px;
            right: 0px;
            height: 20px;
            // width: 40px;
            background-color: antiquewhite;
            line-height: 18px;
            text-align: center;
            padding: 2px 6px;
            background-color: #1890ff;
            color: #fff;
            border: 1px solid #ed6e33;
            border-top-right-radius: 7px;
            border-bottom-left-radius: 10px;
            font-size: 11px;
          }

          .song {
            margin: auto;
            width: 100%;
            line-height: 29px;
            text-align: center;
            font-size: 13px;
            margin-top: 2px;
            background-color: #1890ff;
            // border-radius: 10px;
            color: #fff;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }
        }

      }

      .btnAds {
        width: 150px;
        height: 110px;
        border: #ccc 1px solid;
        border-radius: 10px;
        margin-top: 10px;
        text-align: center;
        line-height: 110px;

        i {
          font-size: 23px;
        }
      }
    }
  }

  .waiAdd {
    width: 80%;
    height: 100%;
    margin: auto;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  // display: flex;
  margin-bottom: 20px;
}
</style>
